import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ShellDomainProvider, UtilityService } from '../../shared/standalone-packages/ecap3/core';
import { map } from 'rxjs/operators';
import { CommonService } from './common.service';
import { MailAuthStatusService } from './mail-auth-status.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SignalrNotificationService } from '../standalone-packages/ecap3/signalr-notification';
import { UrlResolverService } from './url/url-resolver.service';
@Injectable({
    providedIn: 'root'
})
export class AuthorizeMailRedirectService {
    private readonly urlResolver = inject(UrlResolverService);
    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    isRedirectPopupDone: boolean;
    constructor(
        private http: HttpClient,
        private commonService: CommonService,
        private utilityService: UtilityService,
        private signalrNotificationService: SignalrNotificationService,
        private mailAuthService: MailAuthStatusService,
        public snackBar: MatSnackBar,
        private translateService: TranslateService
    ) {}

    getRedirectUrlForCurrentUser() {
        this.commonService.getCurrentRoleUser();
        const currentUserEmail: string = this.commonService.currentLoggedInUser.Email;
        const currentUserId: string = this.commonService.currentLoggedInUser.UserId;
        const apiType =
            currentUserEmail.includes('@gmail.com') || currentUserEmail.includes('@selise.ch')
                ? 'GMAIL_API'
                : 'MICROSOFT_GRAPH';
        const commandId = this.utilityService.getNewGuid();
        const request = {
            Url: `${this.urlResolver.getPcxQueryUrl()}GetEmailAuthorizationUrl`,
            Payload: {
                EmailSyncType: apiType,
                CommandId: commandId,
                IsAdminTokenRequired: false
            }
        };
        this.signalrNotificationService.subscribeSingle(
            'email-authorization',
            commandId,
            'email-authorization',
            (notification: any) => {
                const response = JSON.parse(notification['value']);
                if (
                    response['Success'] &&
                    response['Result']?.AuthorizationStatus === 2 &&
                    response['Result']?.EmailId === currentUserEmail
                ) {
                    this.mailAuthService.isMailAuthorized = true;
                    // let the other screens know this user is now authorized
                    this.mailAuthService.mailAuthorized$.next(currentUserId);
                    const message = this.translateService.instant('EMAIL_AUTH_SUCCESSFUL');
                    this.openSnackBar(message, 4000);
                } else {
                    this.mailAuthService.isMailAuthorized = false;
                    const message = this.translateService.instant('EMAIL_AUTH_FAILED');
                    this.openSnackBar(message, 4000);
                    console.error('Notification failed', response);
                }
            }
        );

        return this.http
            .post(request.Url, request.Payload, { headers: this.header, withCredentials: true, observe: 'response' })
            .pipe(
                map((response: any) => {
                    return response.body;
                })
            );
    }

    private openSnackBar(message: string, duration) {
        this.snackBar.open(message, null, <MatSnackBarConfig>{
            duration: duration,
            horizontalPosition: 'right',
            verticalPosition: 'bottom'
        });
    }
    getRedirectUrlForDepartment(emailId, commandId) {
        const apiType = emailId.includes('@gmail.com') ? 'GMAIL_API' : 'MICROSOFT_GRAPH';
        const request = {
            Url: `${this.urlResolver.getPcxQueryUrl()}GetEmailAuthorizationUrl`,
            Payload: {
                EmailSyncType: apiType,
                CommandId: commandId,
                IsAdminTokenRequired: true
            }
        };

        return this.http
            .post(request.Url, request.Payload, { headers: this.header, withCredentials: true, observe: 'response' })
            .pipe(
                map((response: any) => {
                    return response.body;
                })
            );
    }
}
